import React from 'react'

import { FlowChartCondition } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartConditionNode'

import * as styles from './ConditionText.styles'

interface ConditionTextProps {
  condition: FlowChartCondition
}

export const ConditionText = ({ condition }: ConditionTextProps) => {
  let str = ''

  if (condition.field) {
    str += condition.field
  }

  if (condition.condition) {
    str += ` <secondary>${condition.condition}</secondary>`
  }

  if (condition.value) {
    str += ` ${condition.value}`
  }

  return <richtext text={str} style={styles.ConditionTextStyle} />
}
